import PanelBannerQueueManager from './PanelBannerQueueManager';
export default PanelBannerQueueManager;
